// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"button"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 6H21V18H3V6Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7 10H17V14H7V10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 6H21V18H3V6Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 10H17V14H7V10Z","strokeWidth":"props.strokeWidth"}}]}]};

const ButtonIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'button',
    ref,
    icon: element,
  },
));

ButtonIcon.displayName = 'ButtonIcon';

export default ButtonIcon;
